import { render, staticRenderFns } from "./Greeting.vue?vue&type=template&id=b4c17efa&scoped=true&"
import script from "./Greeting.vue?vue&type=script&lang=js&"
export * from "./Greeting.vue?vue&type=script&lang=js&"
import style0 from "./Greeting.vue?vue&type=style&index=0&id=b4c17efa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c17efa",
  null
  
)

export default component.exports